import React from 'react';
import "../App/App.css";
import About from '../About/About.js';
import ShowsGallery from '../ShowsGallery/ShowsGallery.js';



function Home() {
  return (
    <main>
      <About/>
      <ShowsGallery/>
    </main>

  );
}

export default Home;
